@if (calendar) {
    <mat-card style="max-width: 100%" class="h100">
        <mat-card-header>
            <mat-card-title>
                {{ calendar.name }}
            </mat-card-title>
            <mat-card-subtitle>
                {{ calendar.notes }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            @if (calendar.programs) {
                @for (program of calendar.programs; track program) {
                    @if ($first) {
                        <mat-divider style="margin: 10px"></mat-divider>
                    }
                    <div class="flex-center-center flex-direction-row">
                        <div class="w100 flex-center-center">
                            <span style="font-size: medium;font-weight: normal">{{ 'SensorEvent.intervals'|translate }}</span>
                        </div>
                        <div class="w100 flex-center-center">
                            &nbsp;{{ program.start_hours_html }}:{{ program.start_minutes_html }}
                            &nbsp;-&nbsp;{{ program.end_hours_html }}:{{ program.end_minutes_html }}
                        </div>
                        <div class="w100 flex-center-center">
                            <mat-chip-set>
                                @for (day of program.days; track day) {
                                    <mat-chip>{{ 'weekDay.' + day|translate }}</mat-chip>
                                }
                            </mat-chip-set>
                        </div>
                    </div>
                }
            }

            <mat-chip-set style="max-width: 100%">
                @for (date of calendar.dates; track date) {
                    <mat-chip>
                        {{ date.fromDate|customDate:'mediumDate'|async }}
                        - {{ date.toDate|customDate:'mediumDate'|async }}
                    </mat-chip>
                }
            </mat-chip-set>
            <mat-divider style="margin: 10px"></mat-divider>
            {{ 'SensorEvent.repeatAnnually'|translate }} {{ (calendar.repeatAnnually ? 'yes' : 'no')|translate }}
        </mat-card-content>
    </mat-card>
}